var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.5,
    height: 32.089,
    viewBox: "0 0 35.5 32.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-social-media-black-icon",
    d: "M27.958,0H33.4L21.509,13.593,35.5,32.089H24.545l-8.58-11.218L6.148,32.089H.7L13.421,17.55,0,0H11.232l7.756,10.253ZM26.048,28.83h3.016L9.594,3.087H6.357L26.048,28.83Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSocialMedia);
export default __webpack_public_path__ + "static/media/x-social-media.85d2a14fe82e928ef1f752a6fd6af73e.svg";
export { ForwardRef as ReactComponent };